import React, { Component } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { Table } from 'reactstrap';

import { db } from '../firebase/index';
import RankingDetail from './RankingDetail';
import './Ranking.css';

let RANKINGLIST = [];

class Ranking extends Component {
  state = {
    loaded: false,
    rankingList: RANKINGLIST,
  }
  componentDidMount() {
    this.getOrderedList();
  }
  getOrderedList = () => {
    db.collection("images").orderBy("like", "desc").get().then((querySnapshot) => {
      querySnapshot.forEach((doc) => {
        RANKINGLIST.push(doc);
      });
    }).then(()=>{
      this.setState({
        loaded: true
      });
    });
  }
  handleBack = () => {
    window.history.back();
  }
  render(){
    if (this.state.loaded) {
      library.add(faTimes);
      library.add(faChevronLeft);

      const { rankingList } = this.state;
      const List = rankingList.map(
        (elem, index) => {
          return(
            <tr className="ranking-set" key={index}>
              <RankingDetail index={index} info={elem.data()}/>
            </tr>
          );
        }
      );

      return(
        <div className="ranking ranking-content">
          <div className="ranking-nav">
            <div className="ranking-back" onClick={this.handleBack}><FontAwesomeIcon icon="chevron-left" /></div>
            <a className="ranking-close" href="zepeto://WEBVIEW/CLOSE"><FontAwesomeIcon icon="times" /></a>
          </div>
          <div className="ranking-content-card">
            <div className="ranking-title">
              <span role="img" aria-label="">🏆</span>
              Ranking
            </div>
            <div className="table-wrapper">
              <Table>
                <tbody>
                  {List}
                </tbody>
              </Table>
            </div>
          </div>
          
        </div>
      );
    }
    else {
      return(
        <div></div>
      );
    }
  }
}
export default Ranking;